import React from 'react';

import { ILeadProperty } from '@crm-lead/base';
import { Header } from '@crm-package/layouts';

import { LeadShortHeaderTitle } from './styled';

interface IBaseLeadPreviewHeaderProps extends ILeadProperty {
  title?: string;
}

export const LeadHeader: React.FC<IBaseLeadPreviewHeaderProps> = ({
  lead,
  title,
  children,
}) => (
  <Header>
    <LeadShortHeaderTitle>
      Client Id: {lead?.id} / {title ?? 'Information'}
    </LeadShortHeaderTitle>
    {children}
  </Header>
);
